import { FC } from "react";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { HeaderConfig } from "../../Header/views/HeaderConfig";
import { useSelectedOrganization } from "../../Organizations/hooks/useSelectedOrganization";
import { OrganizationNotFoundView } from "../../Organizations/views/OrganizationNotFoundView";
import { ProjectsView } from "./ProjectsView";

export const ProjectsPage: FC = () => {
  const organizationId = useSelectedOrganization(
    (organization) => organization?.id,
  );

  return (
    <>
      <HeaderConfig variant="WITH_NAVIGATION" />
      <FullHeightContainer maxWidth={false}>
        {organizationId ? (
          <ProjectsView organizationId={organizationId} />
        ) : (
          <OrganizationNotFoundView />
        )}
      </FullHeightContainer>
    </>
  );
};
